export default {
  LOAD_GLOBAL_DATA: 'loadGlobalData',
  LOAD_COUNTRY_DATA: 'loadCountryData',
  LOAD_RADIUS_DATA: 'loadRadiusData',
  LOAD_COUNTRY: 'loadCountry',
  REFRESH_COUNTRY: 'refreshCountry',
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop',
  CHANGE_CURRENT_DATA_INDEX: 'changeCurrentDataIndex',
  CHANGE_DATA_REFRESH_INTERVAL: 'changeDataRefreshInterval',
  CHANGE_DATA_RANGE: 'changeDataRange',
  CHANGE_SET_CANVAS_ENABLED_CALLBACK: 'changeSetCanvasEnabledCallback',
  CALL_SET_CANVAS_ENABLED: 'callSetCanvasEnabled',
  CHANGE_USE_RADIUS: 'changeUseRadius',
  CHANGE_RADIUS: 'changeRadius',
  CHANGE_SET_GLOBE_AUTOROTATION_CALLBACK: 'changeSetGlobeAutorotationCallback',
  CALL_SET_GLOBE_AUTOROTATION: 'callSetGlobeAutorotation',
  CHANGE_GLOBE_AUTOROTATION: 'changeGlobeAutorotation',
  CHANGE_SHOW_TRANSCRIPT: 'changeShowTranscript',
  CHANGE_SHOW_CHART: 'changeShowChart',
  CHANGE_VOLUME: 'changeVolume',
};
